import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Tabs, Tab } from '@mui/material'
import BarChartIcon from '@mui/icons-material/BarChart'
import PieChartIcon from '@mui/icons-material/PieChart'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import DialpadIcon from '@mui/icons-material/Dialpad'
import { operatorReportStyles as opStyles, reportPrimary } from '../../../helpers/style'
import { VIEW_OVERVIEW, VIEW_CALL_COUNT, VIEW_DIRECTIONS, VIEW_NUMBERS } from '../../../helpers/demo'

import { hasReportViewAll } from '../../../helpers/employeePermissions'

const primaryColor = reportPrimary

const allNavBlocks = [
  { view: VIEW_OVERVIEW, icon: PieChartIcon, labelKey: 'tabOverview', color: primaryColor },
  { view: VIEW_CALL_COUNT, icon: BarChartIcon, labelKey: 'tabCallCount', color: primaryColor },
  { view: VIEW_DIRECTIONS, icon: SwapHorizIcon, labelKey: 'tabDirections', color: '#8b5cf6' },
  { view: VIEW_NUMBERS, icon: DialpadIcon, labelKey: 'tabNumbers', color: '#06b6d4', requireReportViewAll: true },
]

export default function ReportTabs({ tabValue, onTabChange, opTr, langIndex }) {
  const employeeData = useSelector((state) => state.users.employeeData)
  const canViewAllReports = hasReportViewAll(employeeData)

  const navBlocks = useMemo(() => {
    return allNavBlocks.filter((b) => !b.requireReportViewAll || canViewAllReports)
  }, [canViewAllReports])

  return (
    <Tabs
      value={tabValue}
      onChange={(_, v) => onTabChange(v || null)}
      variant="fullWidth"
      sx={opStyles.tabs}
    >
      {navBlocks.map((block) => (
        <Tab
          key={block.view || 'overview'}
          value={block.view || ''}
          icon={<block.icon sx={opStyles.tabIcon} />}
          iconPosition="start"
          label={opTr[block.labelKey]?.[langIndex]}
        />
      ))}
    </Tabs>
  )
}
